module.exports = __webpack_public_path__ + "static/media/v_code-client.95160fcd.jpg";